<div style="min-height: 75vh;" ngStyle.gt-sm="{'min-width': '70vw'}">
  <div fxLayout="row" fxLayoutGap="15px">
    <div fxFlex='70%'>
      <h5>{{pageTitle}}</h5>
    </div>
    <div fxFlex='30%'>
      <a href="javascript:void(0)" (click)="onClickClose()" style="color: #8f8f8f">
        <mat-icon style="size: 18px; float: right !important;">close</mat-icon>
      </a>
    </div>
  </div>
  <ebb-contractor-search 
    [appZIP]="this.appZIP"
    [dwellingLat]="this.dwellingLat"
    [dwellingLong]="this.dwellingLong"
    [openOption]="this.openOption"
    [genericLogo]="this.genericLogo"
    [businessLogoRoot]="this.businessLogoRoot"
    [isPortal]="this.isPortal"
    [programtypes]="this.programTypes"
    (sendRequestForEstimateEmit)="this.sendEstimateRequest($event)"
    (closeEmit)="this.onClickClose()"
    (selectContractorEmit)="this.onSelectContractor($event)"
></ebb-contractor-search>
</div>